import React, {useEffect,useState } from 'react';
import Dropzone from 'react-dropzone';
import "./CreateProduct.css";
import Grid from "@mui/material/Grid";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Num2persian from 'num2persian';
import axios from "axios"
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Paper from "@mui/material/Paper";
import {strings} from "../../../strings"
import TextField from "@mui/material/TextField";
import {useDispatch, useSelector} from "react-redux";
import noContent from "../../../Image/noContent.svg"
import {useHistory, useParams} from 'react-router';
import {selToken} from "../../../stores/base/baseSlice";
import {BasicInformation, ContainerHeader} from "../../module";
import {Editor} from '@tinymce/tinymce-react';
import {
    onProductFormChange,
    selProductForm,
    selProductTypes, selProductAttributes, setProductAttributes, initProductForm
} from "../../../stores/product/slice";
import {createProduct, editProduct, getProductById, getProductType} from "../../../stores/product/thunks";
import {FormProductInit, productValidations} from "../../../stores/product/model";
import {example_image_upload_handler} from "../../utils/uploaderTiny";
import useValidation from "../../../validation/useValidation";
import {styled} from '@mui/material/styles';
import {uplaodFileFrom} from "../../../stores/uploader/uploadThunks";
import {notification} from "../../functions/notification/notificationFunction";
import separate from "../../functions/separate/separate";

const R = require('ramda');

const Input = styled('input')({
    display: 'none',
});

function getSteps() {
    return ['درج اطلاعات پایه', 'اطلاعات تکمیلی', 'بارگذاری فایل'];
}


export default function CreateProduct() {

    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const product = useSelector(selProductForm);
    const attributesValue = useSelector(selProductAttributes);
    const {
        name,
        product_type,
        category,
        medias,
        attributes,
        tags,
        description,
        price,
        is_active,
        discounted_price,
        discounted_percent,
        id
    } = product;
    const dispatch = useDispatch();
    const {slug} = useParams();
    const history = useHistory();
    const steps = getSteps();
    const token = useSelector(selToken);
    const [openDialog, setOpenDialog] = React.useState(true);
    const [typeProduct, setTypeProduct] = React.useState("");
    const allProductType = useSelector(selProductTypes);
    const [changeMedia, setChangeMedia] = useState(false);

    const callBackSetAttributes = (res) => {
        let obj = {}
        res.forEach(item => {
            obj = {
                ...obj,
                [item.name]: item.type.value
            }
        })
        return dispatch(setProductAttributes(obj))
    }

    useEffect(() => {
        slug ?
            dispatch(getProductById({slug}, callBackSetAttributes))
            :
            dispatch(getProductType());
        return () => {
            dispatch(setProductAttributes({}))
            dispatch(initProductForm())
        }
    }, [slug])


    const {errors, checkFiled, checkValidation} = useValidation({
        data: productValidations,
        key: 'productForm',
    });


    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    function setParametersMain(event) {
        const {value, name} = event.target;
        if(name === "price"){
            checkFiled(name, value.replaceAll(',', ''));
            dispatch(onProductFormChange({name, value:value.replaceAll(',', '')}))
        }else {
            checkFiled(name, value);
            dispatch(onProductFormChange({name, value}))
        }

    }

    function changeNumberToString(value, name) {
        if (name === "price") {
            if (value !== "" && value !== undefined) {
                return (value / 10).toPersianLetter()
            } else return ""
            // setPriceString("")
        } else {
            if (value !== "" && value !== undefined) {
                return value.toPersianLetter()
            } else return ""
        }
    }

    function backToProducts() {
        history.push('/products');
    }

    async function sendProduct() {
        const dataTable = {
            product_type_id: product_type?.id,
            category_id: [],
            name: name,
            description: description,
            price: price.replaceAll(',', ''),
            attributes: '',
            image: medias,
            tags: [],
            is_active: is_active,
            discounted_percent: discounted_percent
        };
        const formData = new FormData();
        for (let keyName in dataTable) {
            if (keyName === "image") {
                medias.map((x, i) => (
                    formData.append(`medias[${i}]`, medias[i]?.key)
                ))
            } else if (keyName === "attributes") {
                let att = {};
                attributes.map((x, i) => {
                    att = {
                        ...att,
                        [x.id]: x.type.name === "text" ? attributesValue[x.name] : attributesValue[x.name]?.id
                    }
                });
                formData.append(`attributes`, JSON.stringify(att));
            } else if (keyName === "tags") {
                tags.length !== 0 ?
                    tags.map((x, i) => {
                        formData.append(`tags[${i}]`, tags[i].id)
                    })
                    :
                    formData.append(`tags`, [])
            } else if (keyName === "category_id") {
                category.length !== 0 ?
                    category.map((x, i) => {
                        formData.append(`categories[${i}]`, category[i].id)
                    })
                    :
                    formData.append(`categories`, [])
            } else{
                if(dataTable[keyName] !== null){
                    formData.append(keyName, dataTable[keyName]);
                } else  formData.append(keyName, '');
            }
        }
        dispatch(createProduct(formData,backToProducts))
        // await axios({
        //     method: 'post',
        //     url: strings.baseUrl2 + `product`,
        //     data: formData,
        //     headers: {
        //         "content-type": "multipart/form-data",
        //         "Authorization": `Bearer ${token}`
        //     }
        // })
        //     .then(result => {
        //         if (result.data.status_code === 200) {
        //             dispatch(notification("success", "", <h3>با موفقیت ایجاد شد</h3>, false))
        //             history.push('/products');
        //         } else if (result.data.status_code === 401) {
        //             dispatch({type: "SET_ADMIN_TOKEN", data: ""})
        //         }
        //     })
        //     .catch(error => {
        //         console.log(error);
        //     })
    }

    async function EditProduct() {
        const dataTable = {
            product_type_id: product_type?.id,
            category_id: [],
            name: name,
            description: description,
            price: price,
            attributes: '',
            image: medias,
            tags: [],
            is_active: is_active,
            discounted_percent: discounted_percent
        };
        const formData = new FormData();
        for (let keyName in dataTable) {
            if (keyName === "image") {
                 changeMedia && medias.map((x, i) => (
                    formData.append(`medias[${i}]`, medias[i]?.key)
                ))
            } else if (keyName === "attributes") {
                let att = {};
                attributes.map((x, i) => {
                    att = {
                        ...att,
                        [x.id]: x.type.name === "text" ? attributesValue[x.name] : attributesValue[x.name]?.id
                    }
                });
                formData.append(`attributes`, JSON.stringify(att));
            } else if (keyName === "tags") {
                tags.length !== 0 ?
                    tags.map((x, i) => {
                        formData.append(`tags[${i}]`, tags[i].id)
                    })
                    :
                    formData.append(`tags`, [])
            } else if (keyName === "category_id") {
                category.length !== 0 ?
                    category.map((x, i) => {
                        formData.append(`categories[${i}]`, category[i].id)
                    })
                    :
                    formData.append(`categories`, [])
            } else{
                if(dataTable[keyName] !== null){
                    formData.append(keyName, dataTable[keyName]);
                } else  formData.append(keyName, '');
            }
        }
        dispatch(editProduct(id,formData,backToProducts))
        // await axios({
        //     method: 'post',
        //     url: strings.baseUrl2 + `product/${id}`,
        //     data: formData,
        //     headers: {
        //         "content-type": "multipart/form-data",
        //         "Authorization": `Bearer ${token}`
        //     }
        // })
        //     .then(result => {
        //         if (result.data.status_code === 200) {
        //             dispatch(notification("success", "", <h3>با موفقیت ویرایش شد</h3>, false))
        //             history.push('/products');
        //         } else if (result.data.status_code === 401) {
        //             dispatch({type: "SET_ADMIN_TOKEN", data: ""})
        //         }
        //     })
        //     .catch(error => {
        //         console.log(error);
        //     })
    }


    const handleNext = async () => {
        let newSkipped = skipped;
        let nameError = await checkFiled("name", name, "isBack");
        let categoryError = await checkFiled("category", category, "isBack");
        let tagsError = await checkFiled("tags", tags, "isBack");
        let priceError = await checkFiled("price", price, "isBack");
        let mediasError = await checkFiled("medias", medias, "isBack");
        let discounted_percentError = await checkFiled("discounted_percent", discounted_percent, "isBack");

        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }
        if (activeStep === 0) {
            if (nameError || categoryError || tagsError) {
                dispatch(notification("error", "", <h3>پارامتر های قرمز رنگ را پر کنید</h3>, false))
            } else {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                setSkipped(newSkipped);
            }
        } else if (activeStep === 1) {
            if (priceError || discounted_percentError) {
                dispatch(notification("error", "", <h3>پارامتر های قرمز رنگ را پر کنید</h3>, false))
            } else {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                setSkipped(newSkipped);
            }
        } else {
            if(mediasError){
                dispatch(notification("error", "", <h3>عکس انتخاب کنید</h3>, false))
            }else slug ? EditProduct() : sendProduct();
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };


    const handleClose = () => {
        setOpenDialog(false);
    };


    function setAllAttributesOfProductType(data) {
        let obj = {}
        if (data) {
            data.attributes.forEach(item => {
                obj = {
                    ...obj,
                    [item.name]: ''
                }
            })
            dispatch(onProductFormChange({name: 'attributes', value: data.attributes}))
            dispatch(onProductFormChange({
                name: 'product_type', value: {
                    id: data.id,
                    name: data.name,
                    title: data.title,
                    priority: data.priority
                }
            }))
            dispatch(setProductAttributes(obj));
        }
        handleClose()
    }

    async function onDrop(event) {
        let allImages = [];
        const callback = (res) => {
            allImages = [...medias, ...allImages, res];
        }

        await Promise.all([...event.target.files]?.map((file) => {
            return dispatch(uplaodFileFrom({file}, callback))
        }))
        dispatch(onProductFormChange({name: 'medias', value: allImages}))
        setChangeMedia(true)
    }


    function backToProducts() {
        history.push('/products');
    }

    return (
        <>
            {!slug &&
            <Dialog
                aria-labelledby="customized-dialog-title"
                open={openDialog}
                // onClose={() => setOpenDialog(false)}
            >
                <div className="ParentTitleDialogBoxCreateProduct">
                    <h3 className="titleDialogBoxCreateProduct">201- انتخاب نوع محصول جدید</h3>
                    {/*<i*/}
                    {/*    className="fas fa-times c-pointer"*/}
                    {/*    onClick={() => setOpenDialog(false)}*/}
                    {/*/>*/}
                </div>
                <DialogContent dividers>
                    <div className="ParentContentDialogCreateProduct">
                        {allProductType !== null &&
                        allProductType.length !== 0 ? allProductType.map((data, i) => (
                                <h3
                                    key={i}
                                    className={`unitDialogProduct ${typeProduct === data.name ? "selectedTypeProduct" : ""}`}
                                    onClick={() => setTypeProduct(data.name)}
                                >{data.name}</h3>
                            ))
                            :
                            <img src={noContent} alt="" className="noContent"/>
                        }
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus
                            disabled={typeProduct === ""}
                            onClick={() => setAllAttributesOfProductType(allProductType.find(x => x.name === typeProduct))}>
                        تایید
                    </Button>
                </DialogActions>
            </Dialog>
            }
            <Grid item xs={12} sm={12}
                  className="w-100 d-flex flex-column DivParentCreateProduct ContentCreateAttribute">
                <ContainerHeader
                    data={{
                        filter: false,
                        backBtn: true,
                    }}
                    headerTitle="افزودن محصول"
                    backBtnTitle="بازگشت"
                    backBtnAction={backToProducts}
                    // filterAction={(value) => {
                    //     handleSearch(value);
                    // }}
                />

                <Paper className="parentContentCreateProduct">
                    <div className="w-75 divParentStepper">
                        <Stepper activeStep={activeStep}>
                            {steps.map((label, index) => {
                                const stepProps = {};
                                const labelProps = {};
                                if (isStepSkipped(index)) {
                                    stepProps.completed = false;
                                }
                                return (
                                    <Step key={label} {...stepProps}>
                                        <StepLabel {...labelProps}>{label}</StepLabel>
                                    </Step>
                                );
                            })}
                        </Stepper>
                    </div>
                    <div className="w-100">
                        {/*<div className="d-flex flex-column divParentBasicInformation">*/}
                        {/*    {findContent(activeStep)}*/}
                        {/*</div>*/}
                        <div className="w-100">
                            {activeStep === 0 &&
                            <BasicInformation errors={errors} checkFiled={checkFiled} slug={slug}/>
                            }
                            {activeStep === 1 &&
                            <div className="d-flex flex-column">
                                <Grid container spacing={2}
                                      className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                    <Grid item
                                          xs={12} sm={6} lg={4}
                                          className="d-flex justify-content-center align-items-center"
                                    >
                                        <div
                                            className={`d-flex position-relative w-100 blueText h-100`}>
                                            <div
                                                className={`ContentCreateAttribute w-100 pl-0 flex-column justify-content-start`}
                                            >
                                                <TextField
                                                    label={'قیمت'}
                                                    variant="outlined"
                                                    name={'price'}
                                                    value={separate(price)}
                                                    error={errors.price}
                                                    className={`w-100`}
                                                    onChange={(e) => setParametersMain(e)}
                                                />
                                                <h3
                                                    style={{
                                                        opacity: (price !== "")
                                                            ? "1" : "0"
                                                    }}
                                                >{changeNumberToString(price, 'price')} تومان </h3>
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item
                                          xs={12} sm={6} lg={4}
                                          className="d-flex justify-content-center align-items-center"
                                    >
                                        <div
                                            className={`d-flex position-relative w-100 align-items-center`}>

                                            <TextField
                                                label={'درصد تخفیف'}
                                                variant="outlined"
                                                name={'discounted_percent'}
                                                value={discounted_percent}
                                                error={errors.discounted_percent}
                                                className={`w-100`}
                                                onChange={(e) => setParametersMain(e)}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item
                                          xs={12} sm={6} lg={4}
                                          className="d-flex justify-content-center align-items-center"
                                    >
                                        <div
                                            className={`d-flex position-relative w-100 blueText`}>
                                            <TextField
                                                label={`قیمت با تخفیف`}
                                                variant="outlined"
                                                size=""
                                                value={discounted_percent !== "" ? separate(price - Math.round(((price * discounted_percent) / 100))) : ''}
                                                className={`w-100`}
                                                disabled
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item
                                          xs={12}
                                          lg={12}
                                          className="d-flex justify-content-center align-items-center mt-4"
                                    >

                                        <div
                                            className={`ContentCreateAttribute`}
                                        >

                                            <Editor
                                                apiKey={`qsxqm0d3cpymk5zrn2u5ujmpunlep67r3lctb7tjt6t2dpw4`}
                                                init={{
                                                    plugins: 'link image code',
                                                    toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code | link image',
                                                    file_browser_callback_types: 'image',
                                                    images_upload_handler: function (blobInfo, success, failure, progress) {
                                                        example_image_upload_handler(blobInfo, success, failure, progress, token)
                                                    },
                                                    height: 400
                                                }}
                                                value={description}
                                                onEditorChange={(e) => dispatch(onProductFormChange({
                                                    name: 'description',
                                                    value: e
                                                }))}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>
                            }
                            {activeStep === 2 &&
                            <div className="d-flex flex-column">
                                <div className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                    <div className="w-100 d-flex flex-column justify-content-center">
                                        <div>
                                            <div className="d-flex justify-content-between">
                                                <div
                                                    className="d-flex flex-column align-items-center parentTextUploadBox">
                                                    <h3>فایل مورد نظر را در این قسمت رها کنید و یا دکمه
                                                        بارگذاری را کلیک نمایید</h3>
                                                    <h3>حجم فایل برای بارگذاری حداکثر بایستی ۱۰۰ کیلو بایت
                                                        باشد</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <label htmlFor="contained-button-file" className="mt-4">
                                            <Input onChange={onDrop} id="contained-button-file" multiple
                                                   type="file"/>
                                            <Button variant="contained" component="span">
                                                آپلود فایل
                                            </Button>
                                        </label>
                                        <div className="d-flex flex-wrap mt-4">
                                            {medias.map((result, i) => {
                                                const url = result.id ? result.urls.main_pic : result.url;
                                                const id = result.id
                                                return <div className="parentUnitPreviewFile" key={i}>
                                                    <i
                                                        className="fas fa-times c-pointer"
                                                        onClick={() =>{
                                                            // setFiles(files.filter(x => x.name !== result.name))
                                                            dispatch(onProductFormChange({
                                                                name: 'medias',
                                                                value: medias.filter(x => x.id !== id)
                                                            }));
                                                            setChangeMedia(true)
                                                        }}
                                                    />
                                                    <div>
                                                        <img className="w-100 h-100" src={url} alt=""/>
                                                    </div>
                                                </div>
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                            <div className="my-3 mr-4">

                                {activeStep <= 0 &&
                                <Button
                                    onClick={() => setOpenDialog(true)}
                                    className="changeTypeButtonCreateProduct"
                                >
                                    تغییر نوع محصول
                                </Button>
                                }
                                {activeStep !== 0 &&
                                <Button onClick={handleBack}>
                                    مرحله قبلی
                                </Button>
                                }
                                <Button
                                    variant="contained"
                                    onClick={handleNext}
                                    className="continuationButtonCreateProduct mr-3"
                                    // disabled={setDisableNextButton(activeStep)}
                                >
                                    {activeStep === steps.length - 1 ? slug ? 'ویرایش' : 'درج' : `ادامه | ${activeStep + 1}`}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Paper>
            </Grid>
        </>
    );
}
